const maxPercent = 100
const quartersPrYear = 4

export function calculateYearlyProductDiscount(
  quarterlyPrice: number,
  yearlyPrice: number,
): number | null {
  if (yearlyPrice === 0) {
    return null
  }

  const quarterToYearlyPrice = quarterlyPrice * quartersPrYear
  const percentage = calculateDiscountPercentage(
    quarterToYearlyPrice,
    yearlyPrice,
  )

  if (percentage === null || percentage >= maxPercent || percentage <= 0) {
    return null
  }

  return percentage
}

function calculateDiscountPercentage(
  oldPrice: number,
  newPrice: number,
): number | null {
  if (oldPrice <= 0) {
    return null
  }

  if (newPrice < 0) {
    return null
  }

  const discountAmount = oldPrice - newPrice
  const discountPercentage = (discountAmount / oldPrice) * maxPercent

  return Math.floor(discountPercentage)
}
